(() => {
  const initHeaderMenu = () => {
    const header = document.querySelector('.shopify-section-header');
    if (!header) return;

    const inlineMenu = header.querySelector('.list-menu--inline');
    const menuItems = header.querySelectorAll('.list-menu-item');
    const submenus = header.querySelectorAll('.header__submenu');

    if (header.classList.contains('color-background-overlay')) {
      header.addEventListener('mouseenter', () => {
        header.classList.remove('color-background-overlay');
        header.classList.add('color-background-overlay-hidden');
      });
      header.addEventListener('mouseleave', () => {
        const searchDetails = document.querySelector('details-modal.header__search > details');
        const burgerMenu = document.querySelector('burger-menu .burger-menu');
        if (!(searchDetails?.hasAttribute('open') || burgerMenu?.classList.contains('burger-menu--open'))) {
          header.classList.add('color-background-overlay');
          header.classList.remove('color-background-overlay-hidden');
        }
      });
    }

    menuItems.forEach((item) => {
      item.addEventListener('mouseenter', (e) => {
        OpenMegaMenu(item);
      });
      item.addEventListener('focus', () => {
        OpenMegaMenu(item);
      });
    });

    inlineMenu?.addEventListener('mouseleave', (e) => {
      CloseMegaMenu(e);
    });

    const OpenMegaMenu = (item) => {
      header.classList.add('show-megamenu-overlay');
      if (item.classList.contains('list-menu--megamenu') || item.classList.contains('list-menu--custom')) {
        item.classList.add('list-menu--megamenu-visible');
        menuItems.forEach((other) => {
          if (other !== item) {
            other.classList.remove('list-menu--megamenu-visible');
            other.querySelectorAll('.header__submenu--disclosure[open]').forEach((details) => {
              details.removeAttribute('open');
            });
          }
        });
      } else {
        menuItems.forEach((other) => other.classList.remove('list-menu--megamenu-visible'));
      }
    };

    const CloseMegaMenu = (e) => {
      const openDetails = header.querySelectorAll('.header__submenu--disclosure[open]');
      if (openDetails.length > 0) return;

      header.classList.remove('show-megamenu-overlay');
      menuItems.forEach((item) => {
        item.classList.remove('list-menu--megamenu-visible');
        item.querySelectorAll('.header__submenu--disclosure[open]').forEach((details) => {
          details.removeAttribute('open');
        });
      });
    };

    submenus.forEach((submenu) => {
      const backButton = submenu.querySelector('.header__submenu-back');
      backButton?.addEventListener('click', (e) => {
        e.stopPropagation();
        const details = backButton.closest('details');
        if (details) {
          details.removeAttribute('open');
          const summary = details.querySelector('summary');
          setTimeout(() => {
            if (summary) {
              summary.focus();
            } else {
              details.focus();
            }
          }, 0);
        }
      });
    });

    (() => {
      const closeBtn = document.querySelector('.menu-drawer__close-button');
      const headerDrawer = document.querySelector('header-drawer');
      closeBtn?.addEventListener('click', (e) => {
        if (headerDrawer && customElements.get('header-drawer')) {
          headerDrawer.closeMenuDrawer(e);
        }
      });
    })();
  };

  document.addEventListener('shopify:section:load', initHeaderMenu);
  document.addEventListener('shopify:section:unload', initHeaderMenu);
  document.addEventListener('shopify:section:reorder', initHeaderMenu);
  initHeaderMenu();
})();
